import React from 'react';
// import Layout from 'layout';

import { authenticationService } from 'auth/authenticationService.js'

import { Link, withRouter } from 'react-router-dom';
// import withRouter  from 'adds/router/withRouter.js';

import {
    Box,
    Typography,
    Paper,
    TextField, FormControl, MenuItem, Select, 
    FormLabel,RadioGroup,FormControlLabel,Radio,
    Button, 
    // Divider,
    InputLabel, FormHelperText, Grid,
    Alert,
    CircularProgress


} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';


class Vehiculo extends React.Component {
  // This syntax ensures `this` is bound within handleClick.
  // Warning: this is *experimental* syntax.

  constructor(props) {
    super(props);

    this.state = {
      html: {
        form:false,
        view: true,
        error_prt: null,
        get_prt_status: false
      },
      data:{
        vehiculo_uuid:'',
        agno:'',
        patente:'',
        tipo:'',
        marca: '',
        modelo:'',
        version: '',
        puertas: '',
        cilindrada: '',
        hp: '',
        combustible: '',
        transmision: '',
        marchas: '',
        traccion: '',
        pais: '',
        equipamiento: '',
        codigo_sii:'',
        asientos: '',
        motor: '',
        chasis: '',
        color: '',
        sello: '',
        numero_factura: '',
        fecha_factura: '',
        neto_factura: '',
        carga: '',
      },      
      data_prt:null,
      error:{
        patente: false,
        tipo: false,
        marca:false,
        modelo: false,
        transmision: false,
        color: false,
      },
      feedback:{
        patente: '',
        tipo:'',
        marca: '',
        modelo: '',
        transmision: '',
        color: '',
      },
      vehiculo_uuid_redirect:''
    };

    
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditForm = this.handleEditForm.bind(this);
    this.handleCancelEditForm = this.handleCancelEditForm.bind(this);
    this.handleLoadPrt = this.handleLoadPrt.bind(this);
    this.loadFromPrt = this.loadFromPrt.bind(this);

    this.handlePatenteChange = this.handlePatenteChange.bind(this);
  }

  componentDidMount(){
    // console.log(this.props)
    if(this.props.vehiculo.vehiculo_uuid === 'new'){
      this.setState(prevState => ({ 
        html: { ...prevState.html,
                form: true,
                view: false,
        }
      }));
    }
    else{
      this.setState(prevState => ({ 
        html: { ...prevState.html,
                form: false,
                view: true,
        },
        data:this.props.vehiculo
      }));
    }
  }

  componentDidUpdate(prevProps){
    const matches = (obj, source) =>
      Object.keys(source).every(key => obj.hasOwnProperty(key) && obj[key] === source[key]);
    
    if(!matches(this.props.vehiculo, prevProps.vehiculo)){
      this.setState({data: this.props.vehiculo?this.props.vehiculo:null});
    }
  }

  handleLoad(){
    console.log('Entra')
    authenticationService.fetchApi({
        url: '/permisos/vehiculo/'+this.state.data.vehiculo_uuid,
        method: 'GET',
    })
    .then(result => {
      this.setState({data:result},()=>{
        this.setState({
          html: {
            form:false,
            view:true,
          }
        },()=>{this.props.updateVehiculo(result)});
      });
    })
    .catch(err => {

    });
  }

  handleLoadPrt(is_new){
    
    if(this.state.data.patente!==''){
      this.setState(prevState => ({html: {...prevState.html,
        get_prt_status: true
      }}));
      authenticationService.fetchApi({
          url: '/permisos/prt/'+this.state.data.patente,
          method: 'GET',
      })
      .then(result => {
        this.setState({data_prt:result},()=>{
          this.setState(prevState => ({html: {...prevState.html,
            get_prt_status: false
          }}));
        });
        this.setState(prevState => ({html: {...prevState.html,
          error_prt: null,
        }}));
      })
      .catch(err => {
        this.setState(prevState => ({html: {...prevState.html,
          error_prt: 'Hubo un error al consultar el webservice de Prt',
        }}));
      });
    }
    else{
      this.setState(prevState => ({html: {...prevState.html,
        error_prt: 'Debes ingresar primero una patente',
      }}));
    }
  }

  loadFromPrt(campo = null){
    const { data } = { ...this.state };
    const currentState = data;
    
    console.log(1)
    if(campo==='marca' || campo ==='all' ){
      console.log(2)
      if(this.state.data_prt.vehiculo_marca !== ''){
        console.log(3)
        currentState['marca'] = this.state.data_prt.vehiculo_marca;
      }
    }
    if(campo==='agno' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_agno !== ''){
        currentState['agno'] = this.state.data_prt.vehiculo_agno;
      }
    }
    if(campo==='modelo' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_modelo !== ''){
        currentState['modelo'] = this.state.data_prt.vehiculo_modelo;
      }
    }
    if(campo==='chasis' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_numero_chasis !== ''){
        currentState['chasis'] = this.state.data_prt.vehiculo_numero_chasis;
      }
    }
    if(campo==='motor' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_numero_motor !== ''){
        currentState['motor'] = this.state.data_prt.vehiculo_numero_motor;
      }
    }
    if(campo==='tipo' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_tipo_vehiculo !== ''){
        if(this.state.data_prt.vehiculo_tipo_vehiculo==='AUTOMOVIL'){
          currentState['tipo'] = 'Automóvil';
        }
      }
    }
    if(campo==='sello' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_tipo_sello !== ''){
        currentState['sello'] = this.state.data_prt.vehiculo_tipo_sello;
      }
    }
    if(campo==='combustible' || campo ==='all' ){
      if(this.state.data_prt.vehiculo_tipo_combustible !== ''){
        if(this.state.data_prt.vehiculo_tipo_combustible==='BENCINA'){
          currentState['combustible'] = 'Automóvil';
        }
        if(this.state.data_prt.vehiculo_tipo_combustible==='DIESEL'){
          currentState['combustible'] = 'Diesel';
        }
        if(this.state.data_prt.vehiculo_tipo_combustible==='GAS'){
          currentState['combustible'] = 'Gas';
        }
      }
    }
    this.setState({data:currentState});
  }



  handleInputChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;
    
    if(name=='tipo'){
      currentState[name] = value
    }
    else{
      currentState[name] = value.toUpperCase();
    }
    

    this.setState({ data: currentState });

  }
  handlePatenteChange(event){

    const { data } = { ...this.state };
    const { name, value } = event.target;



    let feedback = '';
    let error = false;


    if (value !=='' && /^[a-zA-Z]{4}[0-9]{2}$|^[a-zA-Z]{2}[0-9]{4}$|^[a-zA-Z]{3}[0-9]{3}$/.test(value)) {
      authenticationService.fetchApi({
        url: '/permisos/vehiculo/verificar_patente/',
        method: 'POST',
        body: JSON.stringify({patente:value}),
      })
      .then( response => {
        if('vehiculo_uuid' in response){
          this.setState({vehiculo_uuid_redirect: response['vehiculo_uuid']})
          feedback = 'Este vehículo ya existe.';
          error=true;
        }
        else{
          feedback = '';
          error = false;
        }
      });
    }
    else {
      feedback = 'La patente no es válida. Ejemplo de patente válida:AAAA11';
      error=true;
    }

    this.setState(prevState => ({
      feedback: {...prevState.feedback,
        patente: feedback
      },
      error: {...prevState.status,
        patente: error
      },
      data:{...prevState.data,
        patente: value
      }
    }));
    
  }

  handleSubmit(event) {
    event.preventDefault();

    let ok = true
    let error = this.state.error
    let feedback = this.state.feedback

    if(this.state.data.patente===''||this.state.data.patente===null){
      error['patente']=true
      feedback['patente']='Debes ingresar una patente.'
      ok = false
    }


    if(this.state.error.patente){
      ok = false
    }

    if(this.state.data.email===''||this.state.data.email===null){
      error['tipo']=true
      feedback['tipo']='Debes ingresar un tipo de vehículo.'
      ok = false
    }
    else{
      error['tipo']=false
      feedback['tipo']=''
    }

    if(this.state.data.marca===''||this.state.data.marca===null){
      error['marca']=true
      feedback['marca']='Debes ingresa la marca del automovil'
      ok = false
    }
    else{
      error['marca']=false
      feedback['marca']=''
    }

    if(this.state.data.modelo===''||this.state.data.modelo===null){
      error['modelo']=true
      feedback['modelo']='Debes ingresar el modelo.'
      ok = false
    }
    else{
      error['modelo']=false
      feedback['modelo']=''
    }
    if(this.state.data.agno===''||this.state.data.agno===null){
      error['agno']=true
      feedback['agno']='Debes ingresar el año para el vehículo.'
      ok = false
    }
    else{
      error['agno']=false
      feedback['agno']=''
    }

    
    this.setState({error:error},()=>{
      this.setState({feedback:feedback},()=>{

      });
    });

    if(!ok){
      return null;
    }

    this.setState({
      html: {
        form:false,
        view:true,
      }
    });

    authenticationService.fetchApi({
        url: '/permisos/vehiculo/',
        method: 'POST',
        body: JSON.stringify(this.state.data),
    })
    .then((result)=>{
      this.props.history.push('/permisos/administracion_vehiculo/'+result['vehiculo_uuid']);
      // console.log(this.state.data)
      this.setState({data:result},()=>{
        this.props.updateVehiculo(result);
      });

    })
    .catch(err => {

    });
  }

  handleEditForm(event){

    event.preventDefault();
    this.setState({
      html: {
        form:true,
        view:false,
      }
    });

  }
  handleCancelEditForm(event){
    event.preventDefault();

    if(this.props.vehiculo.vehiculo_uuid === 'new'){
      this.props.history.push('/permisos/vehiculo/');
    }
    else{
      this.handleLoad();
    }
    
    

  }
  render() {
    return (
      <Box>

        <Paper>
          <Box p={2} m={2}>


            {this.state.html.form &&
            <Box>
              <Grid container>
                <Grid item md={6} sm={12}>
                  <Box textAlign='left'>
                    <Box p={1}>
                      <Button startIcon={this.state.html.get_prt_status ? <CircularProgress size={20}/> : <SettingsInputAntennaIcon />}
                              disabled={this.state.html.get_prt_status ? true : false}
                              color='primary' variant='outlined' onClick={this.handleLoadPrt}>
                        Obtener valores desde PRT
                      </Button>
                    </Box>

                    { this.state.data_prt &&
                      <Box p={1}>
                        <Button startIcon={<CompareArrowsIcon/>} color='primary' onClick={(event) => this.loadFromPrt('all')}>
                          Traspasar datos PRT 
                        </Button>
                      </Box>
                    }
                    { this.state.html.error_prt &&
                      <Alert severity='error'>
                        {this.state.html.error_prt}
                      </Alert>
                    }
                  </Box>
                </Grid>
                <Grid item md={6} sm={12}>
                  <Box textAlign='right'>

                    <Box p={1} style={{display:'inline'}}>
                      <Button onClick={this.handleSubmit} color='primary' variant='contained'>Guardar Cambios</Button>
                    </Box>
                    <Box p={1} style={{display:'inline'}}>
                      <Button color='secondary' variant='outlined' onClick={this.handleCancelEditForm}>
                        Cancelar editar
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Box p={1}>
                <Typography variant='caption'>*Campos obligatorios</Typography>
              </Box>
              <Box p={1}>
                <Typography variant='h6'>Identificación del vehículo</Typography>
              </Box>

              <Grid container>
                <Grid item md={4} sm={12}>
                  <Box p={1}>
                    <TextField  name='patente'
                                id='patente'
                                label='Patente*'
                                placeholder='Patente vehículo'
                                fullWidth
                                maxLength='6'
                                value={this.state.data.patente}
                                error={this.state.error.patente}
                                helperText={this.state.feedback.patente}
                                onChange={this.handlePatenteChange}
                                variant="standard"
                                // disabled={this.props.vehiculo.vehiculo_uuid === 'new'? false: true}
                                />
                  </Box>
                </Grid>
                <Grid item md={4} sm={12}>
                  <Box p={1}>
                    <FormControl>
                      <FormLabel id="demo-radio-buttons-group-label">Categoría del vehículo</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="categoria_tipo"
                        value={this.state.data.categoria_tipo}
                        onChange={this.handleInputChange}
                      >
                        <FormControlLabel value="1" control={<Radio />} label="Vehículo liviano" />
                        <FormControlLabel value="2" control={<Radio />} label="Locomoción colectiva" />
                        <FormControlLabel value="3" control={<Radio />} label="Vehículo pesado" />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  <Box p={1}>
                    <FormControl  fullWidth={true}
                                  error={this.state.error.size}
                                  variant="standard"
                                  >
                      <InputLabel id="tipo_label">Tipo de vehículo*</InputLabel>
                      <Select labelId="tipo_label"
                              id="tipo"
                              name="tipo"
                              value={this.state.data.tipo}
                              onChange={this.handleInputChange}
                      >
                        <MenuItem key='0' value=''>&nbsp;</MenuItem>
                        <MenuItem key='Automóvil' value='Automóvil'>Automóvil</MenuItem>
                        <MenuItem key='Furgón' value='Furgón'>Furgón</MenuItem>
                        <MenuItem key='Camión' value='Camión'>Camión</MenuItem>
                      </Select>
                      {this.state.error.tipo &&
                        <FormHelperText>{this.state.feedback.tipo}</FormHelperText>
                      }
                    </FormControl>
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Tipo vehículo (PRT): {this.state.data_prt.vehiculo_tipo_vehiculo}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                </Grid>
                <Grid item md={4} sm={12}>
                  <Box p={1}>
                    <TextField  name='codigo_sii'
                                id='codigo_sii'
                                label='Código SII'
                                placeholder='Código SII'
                                fullWidth
                                maxLength='15'
                                value={this.state.data.codigo_sii?this.state.data.codigo_sii:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                </Grid>
              </Grid>

              <Box p={1}>
                <Typography variant='h6'>Descripción básica del vehículo</Typography>
              </Box>


              <Grid container>
                <Grid item md={6} sm={12}>
                  <Box p={1}>
                    <TextField  name='marca'
                                id='marca'
                                label='Marca*'
                                placeholder='Marca del vehículo*'
                                fullWidth
                                maxLength='100'
                                value={this.state.data.marca?this.state.data.marca:''}
                                error={this.state.error.marca}
                                helperText={this.state.feedback.marca}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Marca (PRT): {this.state.data_prt.vehiculo_marca}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                  <Box p={1}>
                    <TextField  name='modelo'
                                id='modelo'
                                label='Modelo*'
                                placeholder='Modelo*'
                                fullWidth
                                maxLength='200'
                                value={this.state.data.modelo?this.state.data.modelo:''}
                                error={this.state.error.modelo}
                                helperText={this.state.feedback.modelo}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Modelo (PRT): {this.state.data_prt.vehiculo_modelo}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                  <Box p={1}>
                    <TextField  name='agno'
                                id='agno'
                                label='Año vehículo*'
                                placeholder='Año vehículo*'
                                fullWidth
                                maxLength='4'
                                value={this.state.data.agno?this.state.data.agno:''}
                                helperText={this.state.feedback.agno}
                                error={this.state.error.agno}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  {this.state.data_prt &&
                  <Alert severity='info' icon={false}>
                    <Box>
                      <Typography variant='caption' color='textSecondary'>
                        Año (PRT): {this.state.data_prt.vehiculo_agno}
                      </Typography>
                      
                    </Box>
                  </Alert>
                  }
                  <Box p={1}>
                    <TextField  name='color'
                                id='color'
                                label='Color del vehículo'
                                placeholder='Color del vehículo'
                                fullWidth
                                maxLength='200'
                                value={this.state.data.color?this.state.data.color:''}
                                error={this.state.error.color}
                                helperText={this.state.feedback.color}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='asientos'
                                id='asientos'
                                label='Número de asientos'
                                placeholder='Número de asientos'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.asientos?this.state.data.asientos:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                </Grid>
                <Grid item md={6} sm={12}>
                  <Box p={1}>
                    <TextField  name='version'
                                id='version'
                                label='Versión (Algunos modelos tienen más de una versión)'
                                placeholder='Versión'
                                fullWidth
                                maxLength='300'
                                value={this.state.data.version?this.state.data.version:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='puertas'
                                id='puertas'
                                label='Número de puertas'
                                placeholder='Número de puertas'
                                fullWidth
                                maxLength='2'
                                value={this.state.data.puertas?this.state.data.puertas:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='equipamiento'
                                id='equipamiento'
                                label='Equipamiento (De qué?)'
                                placeholder='Equipamiento (De qué?)'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.equipamiento?this.state.data.equipamiento:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>

                  <Box p={1}>
                    <TextField  name='carga'
                                id='carga'
                                label='Carga (peso que puede cargar el vehículo en toneladas)'
                                placeholder='Carga'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.carga?this.state.data.carga:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='sello'
                                id='sello'
                                label='Tipo de Sello'
                                placeholder='Tipo de Sello'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.sello?this.state.data.sello:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Tipo de sello (PRT): {this.state.data_prt.vehiculo_tipo_sello}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                </Grid>
              </Grid>
              
              
              <Box p={1}>
                <Typography variant='h6'>Datos chasis</Typography>
              </Box>

              <Grid container>

                <Grid item md={6} sm={12}>
                  <Box p={1}>
                    <TextField  name='motor'
                                id='motor'
                                label='Código del Motor'
                                placeholder='Código del Motor'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.motor?this.state.data.motor:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Código del motor (PRT): {this.state.data_prt.vehiculo_numero_motor}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                  <Box p={1}>
                    <TextField  name='chasis'
                                id='chasis'
                                label='Código del Chasis'
                                placeholder='Código del Chasis'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.chasis?this.state.data.chasis:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Código del chasís (PRT): {this.state.data_prt.vehiculo_numero_chasis}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                  <Box p={1}>
                    <TextField  name='cilindrada'
                                id='cilindrada'
                                label='Cilindrada'
                                placeholder='Cilindrada'
                                fullWidth
                                maxLength='5'
                                value={this.state.data.cilindrada?this.state.data.cilindrada:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='hp'
                                id='hp'
                                label='Fuerza motor (HP)'
                                placeholder='Fuerza motor (HP)'
                                fullWidth
                                maxLength='5'
                                value={this.state.data.cilindrada?this.state.data.cilindrada:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                </Grid>
                
                <Grid item md={6} sm={12}>
                  <Box p={1}>
                    <FormControl  fullWidth={true}
                                  error={this.state.error.size}
                                  >
                      <InputLabel id="combustible_label">Tipo de combustible</InputLabel>
                      <Select labelId="combustible_label"
                              id="combustible"
                              name="combustible"
                              value={this.state.data.combustible?this.state.data.combustible:''}
                              onChange={this.handleInputChange}
                              variant="standard"
                              >
                        <MenuItem key='0' value=''>&nbsp;</MenuItem>
                        <MenuItem key='Diesel' value='Diesel'>Diesel</MenuItem>
                        <MenuItem key='Bencina' value='Bencina'>Bencina</MenuItem>
                        <MenuItem key='Gas' value='Gas'>Gas</MenuItem>
                      </Select>
                    </FormControl>
                    {this.state.data_prt &&
                    <Alert severity='info' icon={false}>
                      <Box>
                        <Typography variant='caption' color='textSecondary'>
                          Tipo de combustible (PRT): {this.state.data_prt.vehiculo_tipo_combustible}
                        </Typography>
                        
                      </Box>
                    </Alert>
                    }
                  </Box>
                  <Box p={1}>
                    <FormControl  fullWidth={true}
                                  error={this.state.error.size}
                                  >
                      <InputLabel id="transmision_label">Transmisión</InputLabel>
                      <Select labelId="transmision_label"
                              id="transmision"
                              name="transmision"
                              value={this.state.data.transmision?this.state.data.transmision:''}
                              onChange={this.handleInputChange}
                              variant="standard"
                              >
                        <MenuItem key='0' value=''>&nbsp;</MenuItem>
                        <MenuItem key='Manual' value='Manual'>Manual</MenuItem>
                        <MenuItem key='Automática' value='Automática'>Automática</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box p={1}>
                    <TextField  name='marchas'
                                id='version'
                                label='Marchas'
                                placeholder='Marchas'
                                fullWidth
                                maxLength='2'
                                value={this.state.data.marchas?this.state.data.marchas:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>

                  <Box p={1}>
                    <FormControl  fullWidth={true}
                                  error={this.state.error.size}
                                  >
                      <InputLabel id="traccion_label">Tracción</InputLabel>
                      <Select labelId="traccion_label"
                              id="traccion"
                              name="traccion"
                              value={this.state.data.traccion?this.state.data.traccion:''}
                              onChange={this.handleInputChange}
                              variant="standard"
                              >
                        <MenuItem key='0' value=''>&nbsp;</MenuItem>
                        <MenuItem key='Delantera' value='Delantera'>Delantera</MenuItem>
                        <MenuItem key='Trasera' value='Trasera'>Trasera</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  
                </Grid>
              </Grid>
              
            
              
              <Box p={1}>
                <Typography variant='h6'>Datos de facturación</Typography>
              </Box>

              <Grid container>
                <Grid item md={6} sm={12}>
                  <Box p={1}>
                    <TextField  name='numero_factura'
                                id='numero_factura'
                                label='Número de factura'
                                placeholder='Número de factura'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.numero_factura?this.state.data.numero_factura:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='fecha_factura'
                                id='fecha_factura'
                                label='Fecha Factura'
                                placeholder='Fecha Factura'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.fecha_factura?this.state.data.fecha_factura:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>
                  <Box p={1}>
                    <TextField  name='neto_factura'
                                id='neto_factura'
                                label='Monto neto Factura'
                                placeholder='Monto neto Factura'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.neto_factura?this.state.data.neto_factura:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>


                      
                </Grid>
                <Grid item md={6} sm={12}>
                  
                  <Box p={1}>
                    <TextField  name='pais'
                                id='pais'
                                label='País de origen del vehículo'
                                placeholder='País de origen del vehículo'
                                fullWidth
                                maxLength='30'
                                value={this.state.data.pais?this.state.data.pais:''}
                                onChange={this.handleInputChange}
                                variant="standard"
                                />
                  </Box>


                </Grid>
              </Grid>
              <Box textAlign='right'>
                <Box p={1} style={{display:'inline'}}>
                  <Button onClick={this.handleSubmit} color='primary' variant='contained'>Guardar Cambios</Button>
                </Box>

                <Box p={1} style={{display:'inline'}}>
                  <Button color='secondary' variant='outlined' onClick={this.handleCancelEditForm}>
                    Cancelar editar
                  </Button>
                </Box>
              </Box>
            </Box>
            }

            { this.state.html.view &&
            <Box>
              <Box p={1} textAlign='right'>
                <Button startIcon={<EditIcon/>} onClick={this.handleEditForm} color='primary' variant='contained'>Editar Formulario</Button>
              </Box>
              <Grid container>
                <Grid item md={4} sm={12}>
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Patente Vehículo
                    </Typography>
                    <Box>
                      {this.state.data.patente}
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={4} sm={12}>
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Categoria del vehículo
                    </Typography>
                    <Box>
                      { this.state.data?.categoria_tipo===1?"Vehiculo liviano":
                        this.state.data?.categoria_tipo===3?"Vehiculo Pesado":
                        this.state.data?.categoria_tipo===2?"Locomoción colectiva":
                        "Hay un error con el vehículo. Por favor contáctanos en el chat para corregirlo"
                        }
                    </Box>
                  </Box>
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Tipo de vehículo
                    </Typography>
                    <Box>
                      {this.state.data.tipo}
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={4} sm={12}>
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Código SII
                    </Typography>
                    <Box>
                      {this.state.data.codigo_sii}
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              <Box p={1}>
                <Typography variant='h6'>Descripción básica del vehículo</Typography>
              </Box>


              <Grid container>
                <Grid item md={6} sm={12}>
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                    Marca del vehículo
                    </Typography>
                    <Box>
                      {this.state.data.marca}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Modelo
                    </Typography>
                    <Box>
                      {this.state.data.modelo}
                    </Box>
                  </Box>
                  
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Año
                    </Typography>
                    <Box>
                      {this.state.data.agno}
                    </Box>
                  </Box>
                  

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Color del vehículo
                    </Typography>
                    <Box>
                      {this.state.data.color}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Número de asientos
                    </Typography>
                    <Box>
                      {this.state.data.asientos}
                    </Box>
                  </Box>

                </Grid>
                <Grid item md={6} sm={12}>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Versión
                    </Typography>
                    <Box>
                      {this.state.data.version}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Número de puertas
                    </Typography>
                    <Box>
                      {this.state.data.puertas}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Equipamiento
                    </Typography>
                    <Box>
                      {this.state.data.equipamiento}
                    </Box>
                  </Box>
                 
                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Carga en toneladas
                    </Typography>
                    <Box>
                      {this.state.data.carga}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Sello
                    </Typography>
                    <Box>
                      {this.state.data.sello}
                    </Box>
                  </Box>

                </Grid>
              </Grid>
              
              
              <Box p={1}>
                <Typography variant='h6'>Datos chasis</Typography>
              </Box>

              <Grid container>

                <Grid item md={6} sm={12}>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Código del Motor
                    </Typography>
                    <Box>
                      {this.state.data.motor}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Código del Chasis
                    </Typography>
                    <Box>
                      {this.state.data.chasis}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Cilindrada
                    </Typography>
                    <Box>
                      {this.state.data.cilindrada}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      HP
                    </Typography>
                    <Box>
                      {this.state.data.hp}
                    </Box>
                  </Box>
                  
                </Grid>
                
                <Grid item md={6} sm={12}>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Combustible
                    </Typography>
                    <Box>
                      {this.state.data.combustible}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Transmisión
                    </Typography>
                    <Box>
                      {this.state.data.transmision}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Marchas
                    </Typography>
                    <Box>
                      {this.state.data.marchas}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Tracción
                    </Typography>
                    <Box>
                      {this.state.data.traccion}
                    </Box>
                  </Box>
                  
                </Grid>
              </Grid>
              
            
              
              <Box p={1}>
                <Typography variant='h6'>Datos de facturación</Typography>
              </Box>

              <Grid container>
                <Grid item md={6} sm={12}>


                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Número de factura
                    </Typography>
                    <Box>
                      {this.state.data.numero_factura}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Fecha Factura
                    </Typography>
                    <Box>
                      {this.state.data.fecha_factura}
                    </Box>
                  </Box>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      Neto Factura
                    </Typography>
                    <Box>
                      {this.state.data.neto_factura}
                    </Box>
                  </Box>

                </Grid>
                <Grid item md={6} sm={12}>

                  <Box p={1}>
                    <Typography variant='caption' color='textSecondary'>
                      País de origen
                    </Typography>
                    <Box>
                      {this.state.data.pais}
                    </Box>
                  </Box>

                </Grid>
              </Grid>


              <Box p={1} textAlign='right'>
                <Button onClick={this.handleEditForm} color='primary' variant='contained'>Editar Formulario</Button>
              </Box>
            </Box>

            }
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default withRouter(Vehiculo);